import { ButtonType, ButtonWidget, ListItem, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Location } from '~commonInfra/utils/Location';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { openReactAlertDialog } from '~src/commonInfra/dialogs/ReactAlertDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { ScimConfigurationsService } from '../services/ScimConfigurationsService';
import { samlProviderGroupSettings } from '../styles/SAMLAuthenticationProviderStyle';
import { MaxConfigurationsReachedDialog } from './multipleIDPComponents/MaxConfigurationsReachedDialog';
import { ScimConfigurationsDialog } from './scimConfigurationsComponents/ScimConfigurationsDialog';

export interface ScimConfigurationsProps {
    samlProviderDropDownListItems: ListItem[];
    deleteScimIdpConfigurationId: (idToRemove: string) => void;
}

const MAX_LIMIT_ON_TOTAL_ALLOWED_SCIM_CONFIGURATIONS = 20;

class ScimConfigurations extends React.Component<ScimConfigurationsProps> {
    constructor(props: ScimConfigurationsProps) {
            super(props);
        }

    private openSCIMHelp(): void {
        window.open('https://onlinehelp.tableau.com/current/online/en-us/scim_config_online.htm', '_blank');
    }


    private SCIMCannotBeEnabledDialog(): Promise<any> {
        const dialogInstance = openReactAlertDialog({
            title: Messages.cannotCreateScimConfiguration(),
            message: Messages.cannotCreateScimConfigurationMessage(),
            dialogWidth: TabDialogWidth.width375px,
        });
        return Promise.resolve(dialogInstance?.result);
    }

    private hasMaxLimitReachedForScimConfigurations(): Promise<boolean> {
        return ScimConfigurationsService.getAllScimConfigurations(false)
            .then(scimConfigurations => {
                return scimConfigurations.length >= MAX_LIMIT_ON_TOTAL_ALLOWED_SCIM_CONFIGURATIONS;
            });
    }

    handleClick = () => {

        if (this.props.samlProviderDropDownListItems?.length === 0) {
            return this.SCIMCannotBeEnabledDialog();
        }
        this.hasMaxLimitReachedForScimConfigurations().then(isMaxLimitReached => {
            if (isMaxLimitReached) {
                MaxConfigurationsReachedDialog();
                return;
        }
        const urls = siteUrlsSelector(getAppStore().getState());
        const newScimConfigPageUrl = urls.scimNewConfigurationUrl();
        Location.instance.setUrl(newScimConfigPageUrl);
    });};

    private renderScimConfigurations(): JSX.Element {
        return (
            <div className="tb-settings-group" style={{ paddingLeft: 20 }}>
                <div className="tb-settings-group-name" style={{ marginTop: 14 }}>
                    {Messages.siteScimConfigurationsHeading()}
                </div>
                <div className="tb-indent">
                    <div className="tb-settings-control">
                        {Messages.siteScimConfigurationsDesc()}
                        &nbsp;
                        <TextLinkWidget onClick={this.openSCIMHelp} testId={'scim-learn-more-link'}>
                            {Messages.scimLearnMore()}
                        </TextLinkWidget>
                    </div>
                    <div>
                        <div style={samlProviderGroupSettings}>
                            <ButtonWidget
                                className="tb-float-left"
                                buttonType={ButtonType.Outline}
                                onClick={this.handleClick}
                                testId={'new-scim-configuration'}>
                                {Messages.siteNewScimConfiguration()}
                            </ButtonWidget>
                        </div>
                        <div className="tb-data-grid">
                            <ScimConfigurationsDialog deleteScimIdpConfigurationId={this.props.deleteScimIdpConfigurationId}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public render(): JSX.Element {
        return FeatureFlags.multipleScimConfigurationsEnabled
            ? this.renderScimConfigurations()
            : null;
    }
}

export default ScimConfigurations;